import { MillisOnMinute } from "../../../utilities/Constants";
import { PostApi, CreateANewFacility, RegisterNewHandheldPath, PutApi, UpdateHandheldPath } from "../../apis/Api";
import WriteResultMessage from "../../apis/WriteResultMessage";

async function UpdateHandheld(
  editedEntity,
  setResultMessage,
  refreshAction)
{

  await PutApi(UpdateHandheldPath(), editedEntity)
    .then(response => response.json())
    .then(output => WriteResultMessage(output, setResultMessage))
    .then(refreshAction);
}
export default UpdateHandheld;